// import DataReportMergeList from '../components/necessaries/DataReportMergeList.vue'

export default [
    {
        path: 'necessaries/DataReportMergeList',
        component: resolve => require(['@/components/necessaries/DataReportMergeList'],resolve),
        name:'DataReportMergeList',
        meta:{
            // id:'10004',
            node:'necessaries',
            url:'DataReportMergeList',
        }
    },
    { 
        path: 'necessaries/enterpriseLsMergeList', 
        component: resolve => require(['@/components/necessaries/enterpriseLsMergeList'],resolve),
        name:'EnterpriseLsMergeList',
        meta:{
            // id:'833',
            node:'necessaries',
            url:'enterpriseLsMergeList',
        }
    },
    { 
        path: 'necessaries/monitorQueryMergeList', 
        component: resolve => require(['@/components/necessaries/monitorQueryMergeList'],resolve),
        name:'monitorQueryMergeList',
        meta:{
            // id:'850',
            node:'necessaries',
            url:'monitorQueryMergeList',
        }
    },
    { 
        path: 'necessaries/monitorReportMergeList', 
        component: resolve => require(['@/components/necessaries/monitorReportMergeList'],resolve),
        name:'monitorReportMergeList',
        meta:{
            // id:'852',
            node:'necessaries',
            url:'monitorReportMergeList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/necessaries.js